import React, { useEffect } from "react";
import KakaoLogin from "react-kakao-login";
import styled from "@emotion/styled";
import { image } from "../../../theme";

import LoadingSpinner from "@screens/LoadingSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import KakaoUnlinkModal from "../../../components/modal/modal-list/KakaoUnlinkModal";
import { LOCAL_STORAGE_LANGUAGE } from "@utils/api-requests/static-data";
import {
  KakaoLinkInstructionText,
  KakaoLoginError,
  LinkSuccessText,
  UnlinkText,
} from "@utils/lanugauge-settings/static-texts/TranslatedTexts";
import { KakaoLoginButton } from "@components/buttons";
import useKakaoLink from "@hooks/useKakaoLink";

const Success = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  color: "#442B2D",
  fontFamily: theme.fontFamily.primaryFont,
  fontWeight: 600,

  "&>div": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "0 1rem",
  },
}));

const SuccessIconsWrapper = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  gap: "1rem",
}));

const Alert = styled.div(({ theme }) => ({
  color: "red",
  fontFamily: theme.fontFamily.primaryFont,
  marginTop: "1rem",
}));

const KakaoLoginDescription = styled.div(({ theme }) => ({
  marginBottom: "2rem",
  fontFamily: theme.fontFamily.primaryFont,
}));

const UnlinkKakao = styled.div(() => ({
  borderBottom: "1px solid black",
  color: "black",
  fontWeight: 300,
  fontSize: "1.4rem",
  cursor: "pointer",
}));
const LinkKakaoSection = ({ userData, userProfile }) => {
  const lang = localStorage.getItem(LOCAL_STORAGE_LANGUAGE);
  const kakaoId = userProfile?.kakaoId;

  const isEngKo = lang !== "ja" && lang !== "zh-hans" && lang !== "zh-hant";

  const {
    setUnlinkSuccess,
    isKakaoAccount,
    kakaoAlert,
    strivacityAlert,
    unlinkModalOpen,
    unlinkSuccess,
    unlinking,
    isLoading,
    strivacityError,
    unlinkUser,
    updateKakaoId,
    loginSuccess,
    setUnlinkModalOpen,
    setKakaoAlert,
  } = useKakaoLink(userData, userProfile);

  useEffect(() => {
    if (strivacityError) {
      unlinkUser(kakaoId ? kakaoId : userData?.kakaoID);
    }
  }, [kakaoId, strivacityError, unlinkUser, userData?.kakaoID]);

  return (
    isEngKo && (
      <div>
        <KakaoUnlinkModal
          openModal={unlinkModalOpen}
          setOpenModal={setUnlinkModalOpen}
          updateKakaoId={updateKakaoId}
          unlinkSuccess={unlinkSuccess}
          setUnlinkSuccess={setUnlinkSuccess}
          isLoading={unlinking}
        />

        {isLoading || unlinking ? (
          <LoadingSpinner />
        ) : isKakaoAccount ? (
          <Success>
            <div>
              <SuccessIconsWrapper>
                <img
                  src={image.kakaoActive.default}
                  alt="kakao talk"
                  width={30}
                />

                <FontAwesomeIcon icon={faCheck} color="#442B2D" />
              </SuccessIconsWrapper>

              <UnlinkKakao onClick={() => setUnlinkModalOpen(true)}>
                <UnlinkText />
              </UnlinkKakao>
            </div>

            <p>
              <LinkSuccessText />
            </p>
          </Success>
        ) : (
          <div>
            <KakaoLoginDescription>
              <KakaoLinkInstructionText />
            </KakaoLoginDescription>

            <KakaoLogin
              token={process.env.REACT_APP_KAKAO_JAVASCRIPT_KEY}
              onSuccess={loginSuccess}
              onFail={(error) => {
                console.error(error);
                setKakaoAlert(<KakaoLoginError />);
              }}
              onLogout={(data) => console.info(data)}
              render={({ onClick }) => {
                return <KakaoLoginButton onClick={onClick} />;
              }}
            />
          </div>
        )}

        <Alert>{kakaoAlert && kakaoAlert}</Alert>

        <Alert>{strivacityAlert && strivacityAlert}</Alert>
      </div>
    )
  );
};

export default LinkKakaoSection;
